var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#5062F0",
    fillOpacity: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9167 8.14286C13.5945 8.14286 13.3333 7.88702 13.3333 7.57143C13.3333 7.25584 13.5945 7 13.9167 7H17.4167C17.7388 7 18 7.25584 18 7.57143V11C18 11.3156 17.7388 11.5714 17.4167 11.5714C17.0945 11.5714 16.8333 11.3156 16.8333 11V8.95098L12.2875 13.4041C12.0597 13.6272 11.6903 13.6272 11.4625 13.4041L8.95833 10.951L4.99581 14.8326C4.76801 15.0558 4.39866 15.0558 4.17085 14.8326C3.94305 14.6095 3.94305 14.2477 4.17085 14.0245L8.54585 9.7388C8.77366 9.51564 9.14301 9.51564 9.37081 9.7388L11.875 12.1919L16.0084 8.14286H13.9167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphBlue);
export default __webpack_public_path__ + "static/media/graphBlue.df6f03270b163f04833bf6075e75f64a.svg";
export { ForwardRef as ReactComponent };